module.exports = __webpack_public_path__ + "media/src/public/img/payment/cloudpayments-99eeaea9b2ebe62fe1a936e0c857f31b.svg";